//Hide persistent form builder text/logo/link 
$(document).ready(function() {
  if($("#globo-formbuilder-51185").length != 0 ){
    
    // Create a MutationObserver instance
    const observer = new MutationObserver(function(mutationsList, observer) {
      // Your code to handle DOM changes here
      $(".wizard__content > p").remove();
      
    });
    
    // Form builder ID
    const targetNode = document.getElementById('globo-formbuilder-51185');
    
    // Start observing the selected element by ID
    observer.observe(targetNode, {
      childList: true,
      subtree: true
    });
  }
  if($("#wishlist-page-contain").length != 0 ){
    
    // Create a MutationObserver instance
    const observer = new MutationObserver(function(mutationsList, observer) {
      // Your code to handle DOM changes here
       console.log("test");
      $('.wishlist-column').each(function(index, element) {
        console.log(element);
      });
    });
    
    // Form builder ID
    const targetNode = document.getElementById('wishlist-page-contain');
    
    // Start observing the selected element by ID
    observer.observe(targetNode, {
      childList: true,
      subtree: true
    });
  }

  // Accordion
  $('.accordion').on('click', function() {
    var details = $(this).find('details');
    
    // Get the id of the 'details' element
    if (!details.attr('open')) {
        $('.accordion').each(function(index, element) {
            $(element).find('details').removeAttr('open');
        });
    }
    
    // Scroll to the clicked header
      $('html, body').animate({
        scrollTop: $(this).offset().top - 95
      }, 375); // Adjust the duration for the smooth scroll effect
    
  });
  // Run only on the terms-and-conditions page (live or preview)
  if (window.location.pathname.includes("/terms-and-conditions")) {
    enhanceBulletInH6();
  }
  function enhanceBulletInH6() {
    $("h6").each(function () {
      var $this = $(this);
      var text = $this.text().trim();

      if (text.startsWith("•")) {
        var bulletSpan = $('<span>')
          .text("•")
          .css({
            "font-size": "18px",
            "font-weight": "600",
            "margin-right": "5px"
          });

        var restText = document.createTextNode(text.slice(1).trim());

        $this.empty().append(bulletSpan).append(restText);
      }
    });
  }
  
});